import { motion } from 'framer-motion';

import { Heading } from '@/components/heading';
import { PortInterface } from '@/types';
import { tv } from '@/utils/styles';

import { PortsCountBox } from './count-box';

const PortsInfo = ({
  ports,
  portsWithinViewPort,
  isSearchingAllPorts,
}: {
  ports: PortInterface[];
  portsWithinViewPort: PortInterface[];
  isSearchingAllPorts: boolean;
}) => {
  const { headingItem } = styles();

  return (
    <>
      <div className={headingItem()}>
        <motion.div
          initial="visible"
          animate={isSearchingAllPorts ? 'visible' : 'hidden'}
          variants={{
            hidden: { opacity: 0, transition: { delay: 0.4 } },
            visible: { opacity: 1 },
          }}
          transition={{ ease: 'easeInOut', duration: 0.3 }}
        >
          <Heading variant="h4" className="mb-0 text-grey-400">
            Loading port data&hellip;
          </Heading>
        </motion.div>
      </div>
      <div className={headingItem()}>
        <motion.div
          initial="hidden"
          animate={isSearchingAllPorts ? 'hidden' : 'visible'}
          variants={{
            hidden: { opacity: 0, x: -4 },
            visible: { opacity: 1, x: 0 },
          }}
          transition={{ ease: 'easeInOut', duration: 0.5, delay: 0.6 }}
        >
          <Heading variant="h4" className="m-0">
            Ports
          </Heading>
        </motion.div>
      </div>
      <PortsCountBox filteredPorts={portsWithinViewPort} ports={ports} isSearchingAllPorts={isSearchingAllPorts} />
    </>
  );
};

const styles = tv({
  slots: {
    headingItem: 'absolute left-4 2xl:left-5',
  },
});

export { PortsInfo };
